<div class="container-fluid px-0" dir="rtl">
  <section class="chart-wrapper">
    <div class="chart-box">
      <canvas id="myChart"></canvas>
    </div>
  </section>
</div>
